var $ = require('jquery');

module.exports = {
	init: function () {
		const observer = new MutationObserver((mutations) => {
			mutations.forEach((mutation) => {
				if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
					mutation.addedNodes.forEach((node) => {
						// Check if the added node is the element you are looking for
						// For example, if you are looking for a div with a specific class:
						if (
							node.nodeType === Node.ELEMENT_NODE &&
							node.classList.contains('skiptranslate')
						) {
							//console.log('Element with class "your-target-class" added:', node);
							this.modifyWidget();
						}
					});
				}
			});
		});
		const targetNode = document.getElementById('google_translate_element'); // Or a specific parent element
		const config = { childList: true, subtree: true }; // Observe child list changes and in the entire subtree

		observer.observe(targetNode, config);
	},
	modifyWidget: function () {},
};
